import { gql } from 'graphql-request';

import { MayBe } from '../../../types';

import {
  OperationBody,
  OperationCompleteDatetime,
  OperationCreatedAt,
  OperationDate,
  OperationState,
  OperationSubject,
  OperationType,
  OperationUUID,
  OperationClientID,
  OperationTeamID,
  OperationUserUUID,
  OperationUserNanoID,
  OperationUserFullName,
  OperationUserImageFile,
  OperationUserImageUUID,
  OperationUserClient,
  OperationUserCurrentTeamNanoID,
  OperationFileAttachmentUUID,
  OperationFileAttachmentID,
  OperationFileAttachmentFile,
  OperationFileAttachmentName,
  OperationFileAttachmentSize,
  OperationFileAttachmentExt,
  OperationFileAttachmentCreatedAt,
  OperationID,
  OperationTaskNanoID,
  OperationTaskName,
  OperationTaskProjectNanoID,
  OperationTaskProjectName,
  OperationProjectNanoID,
  OperationProjectName,
  OperationTeamNanoID,
  OperationTeamName,
  OperationTeamImageFile,
  OperationFileAttachmentOriginalFileName
} from '../operationsTypes';

export interface FetchOperationsQueryResponse {
  id: OperationID;
  uuid: OperationUUID;
  body: OperationBody;
  subject: OperationSubject;
  operationType: OperationType;
  state: OperationState;
  createdAt: OperationCreatedAt;
  date: OperationDate;
  completeDatetime: OperationCompleteDatetime;
  project: MayBe<{
    nanoId: OperationProjectNanoID;
    name: OperationProjectName;
  }>;
  task: MayBe<{
    nanoId: OperationTaskNanoID;
    name: OperationTaskName;
    project: {
      nanoId: OperationTaskProjectNanoID;
      name: OperationTaskProjectName;
    };
  }>;
  fileAttachments: {
    id: OperationFileAttachmentID;
    uuid: OperationFileAttachmentUUID;
    file: OperationFileAttachmentFile;
    name: OperationFileAttachmentName;
    originalFilename: OperationFileAttachmentOriginalFileName;
    size: OperationFileAttachmentSize;
    ext: OperationFileAttachmentExt;
    createdAt: OperationFileAttachmentCreatedAt;
  }[];
  user: {
    uuid: OperationUserUUID;
    nanoId: OperationUserNanoID;
    fullName: OperationUserFullName;
    client: OperationUserClient;
    currentTeam: MayBe<{
      nanoId: OperationUserCurrentTeamNanoID;
    }>;
    image: {
      uuid: OperationUserImageUUID;
      file: OperationUserImageFile;
    };
  };
  client: {
    id: OperationClientID;
    uuid: OperationUserUUID;
    nanoId: OperationUserNanoID;
    fullName: OperationUserFullName;
    client: OperationUserClient;
    currentTeam: MayBe<{
      nanoId: OperationUserCurrentTeamNanoID;
    }>;
    image: {
      uuid: OperationUserImageUUID;
      file: OperationUserImageFile;
    };
  };
  team: {
    nanoId: OperationTeamNanoID;
    name: OperationTeamName;
    image: {
      file: OperationTeamImageFile;
    };
  };
  teamId?: OperationTeamID;
}

export const FETCH_OPERATIONS_QUERY = gql`
  query Operations(
    $filters: OperationsFilters
    $sort: [OperationsSortEnum!]
    $limit: Int
    $offset: Int
  ) {
    operations(filters: $filters, sort: $sort, offset: $offset, limit: $limit) {
      nodes {
        id
        uuid
        body
        subject
        operationType
        state
        completeDatetime
        createdAt
        date
        project {
          nanoId
          name
        }
        task {
          nanoId
          name
          project {
            nanoId
            name
          }
        }
        fileAttachments {
          id
          uuid
          file
          name
          originalFilename
          size
          ext
          createdAt
        }
        user {
          uuid
          nanoId
          fullName
          client
          currentTeam {
            nanoId
          }
          image {
            uuid
            file
          }
        }
        client {
          id
          uuid
          nanoId
          fullName
          client
          currentTeam {
            nanoId
          }
          image {
            uuid
            file
          }
        }
        team {
          nanoId
          name
          image {
            file
          }
        }
        teamId
      }
      paginationInfo {
        totalCount
      }
      sql
    }
  }
`;
